import { ContentType, SoftwarePlan } from 'api/contentful/contentTypes.cloverdotcom';
import { useContentful } from 'hooks/useContentful';
import { ONE_HOUR_IN_MS } from 'globalConstants';
import { useQuery } from '@tanstack/react-query';

export const useContentfulSoftwarePlansQuery = () => {
  const softwarePlans = useContentful<SoftwarePlan>({
    contentType: ContentType.SOFTWARE_PLAN,
    include: 5,
  });

  return useQuery(['contentfulSoftwarePlans'], () => softwarePlans?.data, {
    staleTime: ONE_HOUR_IN_MS,
    enabled: !!softwarePlans?.data,
  });
};
